/**
 * Application Configuration
 * 
 * This file is auto-generated based on environment variables.
 * Environment: production
 * Do not edit this file directly.
 */

const config = {
  // Environment
  nodeEnv: 'production',
  
  // API Configuration
  apiBaseUrl: 'https://api-www.campaignstudio.tv',
  axiosOrigin: 'https://api-www.campaignstudio.tv',
  
  // Socket.IO Configuration
  socketIoBaseUrl: 'https://api-www.campaignstudio.tv',
  
  // Storage Configuration
  s3BaseUrl: 'https://icast-production-us-east-1.s3.us-east-1.amazonaws.com',
  cloudfrontBaseUrl: 'https://d2drli674988c1.cloudfront.net',
  
  // Feature Flags
  features: {
    enableAnalytics: true,
    enableNotifications: true,
  },
  
  // Other Configuration
  defaultTimezone: 'UTC',
  defaultLanguage: 'en',
  itemsPerPage: 10,
};

export default config;
